export default __webpack_public_path__ + "static/media/CRNA-E.ea3ec462.jpg";